import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class AccessSetService {


  constructor(private http: HttpClient) { }


  url = environment.serverAPI + '/api';

  unAssignedAccessSet(accessSetIds: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/accessSet/accessSetNotInProfile`, accessSetIds);
  }

  getAccessSet(Page: number, size: number, sort): Observable<Object> {
		return this.http.get(`${this.url}/accessSet?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAccessSetDropDown(): Observable<Object> {
		return this.http.get(`${this.url}/accessSet/dropdown`);
  }


  getAccessSetById(accessSetId: number,type:any): Observable<Object> {
    return this.http.get(`${this.url}/accessSet/${accessSetId}/${type}`);
  }
  AddOrEditAccessSet(accessSet: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/accessSet`, accessSet);
  }
  
  accessSetSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/accessSet/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  accessSetNameVerified(name: any): Observable<Object> {
		return this.http.get(`${this.url}/accessSet/check/${name}`);
  }

  getUserId(): Observable<Object> {
		return this.http.get(`${this.url}/access/user/id`);
  }


}
